import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { store } from "@store/StoreConfig";
import { Badge } from "reactstrap";
import { BsMusicNoteList } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { getPlaylistById } from "@store/action/multimedia/PlaylistAction";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import Filter from "../Filter";
import Comment from "./Comment";
import BreadCrumbs from "@components/breadcrumbs/index1";

const PlaylistId = () => {
  const playlist = useSelector((state) => state.PlaylistReducer);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const shareUrl = window.location.href;
  const id = useParams().id;
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  let data = {
    currentsong: null,
    download: null,
    namesong: null,
    is_web_rtc: false,
    songimg: "",
  };
  useEffect(() => {
    dispatch(getPlaylistById(id));
  }, [dispatch, id]);

  const renderPlaylist = () => {
    return (
      playlist?.single && (
        <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 shop_sidebar">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="artist_wrapper_content ms_cover">
                <img
                  src={playlist?.single[0]?.picture}
                  className="img-responsive"
                  height="250px"
                  alt="img"
                />
                <div className="artist_wrapper_text">
                  <div className="artist_wrapper_left">
                    <h1> {playlist?.single[0]?.name}</h1>

                    <p>
                      {t("description")} : {playlist.single[0]?.description}
                    </p>
                    <p>
                      {t("Media count")}: : {playlist.single[0]?.media_count}
                    </p>
                    <p>
                      {t("Tags")} :
                      {playlist.single[0]?.tags?.map((el, i) => (
                        <Badge className="ms-1" color="secondary" key={i} pill>
                          {el.name}
                        </Badge>
                      ))}
                    </p>
                    <span>
                      {t("Duration")} : {playlist?.single[0]?.playtime_string}
                    </span>
                    <div className="artist_btn ms_cover">
                      <div className="lang_apply_btn">
                        {PlayerFrontOfficeReducer?.currentSong ===
                        playlist?.single[0]?.file_path ? (
                          <a>
                            <BsMusicNoteList size={20} />
                          </a>
                        ) : (
                          <a
                            onClick={() =>
                              store.dispatch(
                                addMusic(
                                  (data = {
                                    currentsong: playlist?.single[0]?.file_path,
                                    namesong: `${playlist?.single[0]?.name}`,
                                    item_data: playlist?.single[0],
                                    is_web_rtc: false,
                                    has_video:
                                      playlist?.single[0].media?.filter(
                                        (el) => el.media_type_id === 3
                                      )?.length > 0
                                        ? true
                                        : false,
                                    songimg: playlist?.single[0]?.picture,
                                  })
                                )
                              )
                            }
                          >
                            <i className="flaticon-play-button"></i>
                            {t("play")}
                          </a>
                        )}
                      </div>
                      <div className="cancel_wrapper">
                        <ul
                          className="blog-icon-podcast"
                          style={{
                            textAlign: "center",
                            marginTop: "8px",
                            marginLeft: "15px",
                          }}
                        >
                          <li>
                            <FacebookShareButton url={shareUrl}>
                              <FacebookIcon size={30} round={true} />
                            </FacebookShareButton>
                          </li>

                          <li>
                            <TwitterShareButton url={shareUrl}>
                              <TwitterIcon size={30} round={true} />
                            </TwitterShareButton>
                          </li>
                          <li>
                            <WhatsappShareButton url={shareUrl}>
                              <WhatsappIcon size={30} round={true} />
                            </WhatsappShareButton>
                          </li>
                          <li>
                            <FacebookMessengerShareButton url={shareUrl}>
                              <FacebookMessengerIcon size={30} round={true} />
                            </FacebookMessengerShareButton>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Comment t={t} />
        </div>
      )
    );
  };

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={t("Playlist Details")} />
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <Filter
              t={t}
              PlaylistReducer={playlist}
              dispatch={dispatch}
              path="playlists"
            />
            {renderPlaylist()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaylistId;
